import type {TooltipProps} from 'platform/components';

import {TOOLTIP_OPEN_DELAY} from '../constants/tooltipOpenDelay';
import type {EagRowNode} from '../types/EagRowNode';
import type {RowData} from '../types/RowData';
import type {TooltipGetter} from '../types/TooltipGetter';

/**
 * Computes TooltipProps for a cell/row by calling the consumer-provided
 * propsGetter and applying defaults (openDelay, isDisabled when no content).
 *
 * This is a pure function — NOT a hook. It has zero React hook calls.
 */
export const getTooltipProps = (
  data: RowData,
  propsGetter?: TooltipGetter,
  node: EagRowNode = {} as EagRowNode
): TooltipProps => {
  const tooltipProps: TooltipProps = propsGetter ? propsGetter({data, node}) : ({} as TooltipProps);

  const haveContent = tooltipProps.label !== undefined || tooltipProps.description !== undefined;
  const isDisabled = tooltipProps.isDisabled ?? !haveContent;

  return {
    openDelay: TOOLTIP_OPEN_DELAY,
    ...tooltipProps,
    isDisabled,
  };
};
